import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import Select from './Select';

import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import {
  clearSupplierFoodType,
  getSupplierFoodType,
} from '../../../../actions';

const SupplierFoodSelect = ({
  supplierId,
  dispatchGetSupplierFoodType,
  dispatchClearSupplierFoodType,
  foods,
  isLoading,
  isMulti,
  input,
  meta,
  ...rest
}) => {
  useEffect(() => {
    if (supplierId) {
      dispatchGetSupplierFoodType({ supplierId: supplierId.value });
    } else {
      dispatchClearSupplierFoodType();
      input.onChange([]);
    }
  }, [supplierId]);

  return (
    <Select
      options={foods}
      isLoading={isLoading}
      isMulti={isMulti}
      isDisabled={!supplierId}
      input={input}
      meta={meta}
      {...rest}
    />
  );
};

SupplierFoodSelect.propTypes = {
  supplierId: PropTypes.number,
  dispatchGetSupplierFoodType: PropTypes.func.isRequired,
  dispatchClearSupplierFoodType: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  meta: metaPropTypes,
  foods: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    }),
  ),
  isLoading: PropTypes.bool,
};

SupplierFoodSelect.defaultProps = {
  supplierId: null,
  input: inputDefaultProps,
  meta: metaDefaultProps,
  foods: [],
  isLoading: false,
  isMulti: false,
};

const selector = formValueSelector('ItineraryFoodForm');

const mapStateToProps = (state, ownProps) => {
  const inputName = ownProps.input ? ownProps.input.name : '';

  const match = inputName.match(/itineraryScheduleFoodRequestList\[(\d+)\]/);

  const index = match ? Number(match[1]) : null;

  const supplierId =
    index !== null
      ? selector(state, `itineraryScheduleFoodRequestList[${index}].supplierId`)
      : null;

  const supplierFoodTypeList = state.FoodUnit.Supplier.getIn([
    'foodType',
    'content',
  ]);

  const list = supplierFoodTypeList ? supplierFoodTypeList.toJS() : [];

  const foods = list
    .filter(
      (item, indexItem, array) =>
        array.findIndex((x) => x.foodId === item.foodId) === indexItem,
    )
    .map((item) => ({
      value: item.foodId,
      label: item.food ? item.food.name : '',
    }));

  return {
    supplierId,
    foods,
    isLoading: !state.FoodUnit.Supplier.getIn([
      'foodType',
      'activity',
    ]).isEmpty(),
  };
};

const mapDispatchToProps = {
  dispatchGetSupplierFoodType: getSupplierFoodType,
  dispatchClearSupplierFoodType: clearSupplierFoodType,
};

export default connect(mapStateToProps, mapDispatchToProps)(SupplierFoodSelect);
